import { FitBuilderPage } from './FitBuilderPage';

// "Add a Fit" is the builder pre-configured to log a wear at creation time.
// The "To Buy" / wishlist path is out of scope and intentionally omitted.
export function FitAddPage() {
  return <FitBuilderPage withWearToggle aiAssist={false} section="Add a Fit" />;
}
